
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/single_post/[single_post]",
      function () {
        return require("private-next-pages/single_post/[single_post].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/single_post/[single_post]"])
      });
    }
  